export default __webpack_public_path__ + "static/example-65221f4219ea72b16b471120642aa55b.webp";